var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 41,
    rx: 5.5,
    fill: "white",
    stroke: "#ECEDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 36C61 38.7614 58.7614 41 56 41L6 41C3.23857 41 1 38.7614 1 36V33L61 33V36Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27C30.9706 27 35 22.9706 35 18C35 13.0294 30.9706 9 26 9C21.0294 9 17 13.0294 17 18C17 22.9706 21.0294 27 26 27Z",
    fill: "#EE0005"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 27C41.9706 27 46 22.9706 46 18C46 13.0294 41.9706 9 37 9C32.0294 9 28 13.0294 28 18C28 22.9706 32.0294 27 37 27Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 10.875C29.371 12.521 28 15.1001 28 17.9995C28 20.8988 29.371 23.4779 31.5 25.1239C33.629 23.4779 35 20.8988 35 17.9995C35 15.1001 33.629 12.521 31.5 10.875Z",
    fill: "#FF6300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.80ba1409ce2bf1a1a2a796ca89544087.svg";
export { ForwardRef as ReactComponent };